import { tableData } from '../../sample-data/admindata';
import TableStatus from './TableStatus';

// fetch data via api to get TableStatus

function Tables() {
  return (
    <div className="Tables">
      <TableStatus tableData={tableData} />
    </div>
  );
}

export default Tables;